const ZONES_UPDATED = 'ZONES_UPDATED';
export const RESET_DATA_CHANGE = 'RESET_DATA_CHANGE';

const defaultData = {
  zones: 0,
};

let zones = 0;
let zonesChangedTimeout = 0;

export const zonesChanged = () => async (dispatch) => {
  clearTimeout(zonesChangedTimeout);
  zonesChangedTimeout = setTimeout(() => {
    dispatch({ type: ZONES_UPDATED, payload: ++zones });
  }, 1000);
};

export default function reducer(state = defaultData, action) {
  switch (action.type) {
    case ZONES_UPDATED:
      return { ...state, zones: action.payload };
    case RESET_DATA_CHANGE:
      return defaultData;
    default:
      break;
  }
  return state;
}
